import * as React from 'react';
import { useCallback } from 'react';
import { Button } from 'reactstrap';
import { exampleJob } from '../../../settings';
import { IMutation } from '../types/mutation';
import { useInputContext } from "../context/input-context";

interface Props {
  clearGlobalFilter (): void,
  disabled?: boolean,
}

const LoadExample = ({clearGlobalFilter, ...props}: Props) => {

  const {
    rows: allRows,
    setRowSelected,
    setTargetSelected,
    setMutations,
  } = useInputContext();

  const loadExample = useCallback(() => {
    const row = allRows.find(r => r.code === exampleJob.code) || null;
    if (!row) {
      console.error("No target protein row for protein code", exampleJob.code);
      return;
    }
    if (row.proteins.length !== 1) {
      console.warn("Number of isoforms is not 1", exampleJob.code, row);
    }
    setRowSelected(row);
    setTargetSelected(row.proteins[0]);
    const mut: IMutation = {
      position: exampleJob.position,
      units: [ exampleJob.targetAA ],
    }
    setMutations([ mut ]);
    clearGlobalFilter();
  }, [allRows, setRowSelected, setTargetSelected, setMutations, clearGlobalFilter]);
  const disabled = props.disabled || !allRows?.length;
  return (
    <Button onClick={loadExample} disabled={disabled}>
      Load example
    </Button>
  )
}

export default LoadExample;
